var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_1944",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4 23.4001V0.600061H0.6V23.4001H23.4Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_1944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49929 9.4322C6.49929 10.4381 5.6838 11.2536 4.67785 11.2536C3.6719 11.2536 2.8564 10.4381 2.8564 9.4322C2.8564 8.42625 3.6719 7.61075 4.67785 7.61075C5.6838 7.61075 6.49929 8.42625 6.49929 9.4322Z",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16749 7.3567C10.4862 6.54845 12.2041 6.8804 13.1268 8.12175L13.1653 8.12921C14.4841 7.32082 16.2021 7.65282 17.1248 8.89426L17.1633 8.90171C18.4822 8.09303 20.2006 8.42507 21.1233 9.66689L21.1397 9.67004C21.1474 9.34061 21.1764 4.43578 16.1217 3.45906C11.067 2.48242 9.26664 7.04499 9.15105 7.35355L9.16749 7.3567Z",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.33 7.55405L13.8813 15.0514",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.402 2.00013L16.2009 3.04063",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0676 18.4725C19.0799 16.1887 15.7188 14.6877 11.9072 14.6877C8.09549 14.6877 4.73444 16.1887 2.74666 18.4725",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 19.209C2.0907 19.209 2.0907 18.3484 3.18139 18.3484C4.27213 18.3484 4.27213 19.209 5.36287 19.209C6.45356 19.209 6.45356 18.3484 7.54426 18.3484C8.63495 18.3484 8.63495 19.209 9.72569 19.209C10.8164 19.209 10.8164 18.3484 11.907 18.3484C12.9977 18.3484 12.9977 19.209 14.0884 19.209C15.1792 19.209 15.1792 18.3484 16.2699 18.3484C17.3606 18.3484 17.3606 19.209 18.4513 19.209C19.5422 19.209 19.5422 18.3484 20.633 18.3484C21.7239 18.3484 21.7239 19.209 22.8148 19.209",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 22C2.0907 22 2.0907 21.1394 3.18139 21.1394C4.27213 21.1394 4.27213 22 5.36287 22C6.45356 22 6.45356 21.1394 7.54426 21.1394C8.63495 21.1394 8.63495 22 9.72569 22C10.8164 22 10.8164 21.1394 11.907 21.1394C12.9977 21.1394 12.9977 22 14.0884 22C15.1792 22 15.1792 21.1394 16.2699 21.1394C17.3606 21.1394 17.3606 22 18.4513 22C19.5422 22 19.5422 21.1394 20.633 21.1394C21.7239 21.1394 21.7239 22 22.8148 22",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/Travel.8ecfa266db6f50605e177d3b5bffc8da.svg";
export { ForwardRef as ReactComponent };